import { render } from "./SoundIcon.vue?vue&type=template&id=fbc725fa&bindings={\"muted\":\"props\"}"
import script from "./SoundIcon.vue?vue&type=script&lang=js"
export * from "./SoundIcon.vue?vue&type=script&lang=js"

import "./SoundIcon.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script